<div class="email-sms-container">
  <!-- Communication Type Selector -->
<div class="communication-selector" *ngIf="currentLead">
  <div class="left-section">
    <!-- Selector tabs container -->
    <div class="selector-container">
      <div class="selector-tabs">
        <button class="selector-tab" [ngClass]="{'active': !isSms}" (click)="selectCommunicationType('email')">
          <mat-icon>alternate_email</mat-icon>
          <span>Email</span>
        </button>
        <button class="selector-tab" [ngClass]="{'active': isSms}" (click)="selectCommunicationType('sms')">
          <mat-icon>sms</mat-icon>
          <span>SMS</span>
        </button>
      </div>
    </div>
    
    <!-- Meeting scheduler icon moved here -->
    <div class="meeting-scheduler">
      <mat-icon class="scheduler-icon" 
                matTooltip="Pick times" 
                matTooltipPosition="below" 
                (click)="openMeetingScheduler()" 
                style="cursor: pointer;">schedule</mat-icon>
    </div>
  </div>
  
  <!-- Lead Preference Section -->
  <div class="preference-container" *ngIf="currentLead.preferred_contact_method">
    <div class="preference-label">
      <mat-icon class="preference-icon">person_pin</mat-icon>
      <span>Lead prefers {{currentLead.preferred_contact_method}}</span>
    </div>
  </div>
  
  <!-- No Preference Message -->
  <div class="no-preference" *ngIf="!currentLead.preferred_contact_method">
    <mat-icon>info</mat-icon>
    <span>Lead has no contact preference</span>
  </div>
</div>
  
  <div *ngIf="currentLead" class="test" [style.backgroundColor]="createEmail ? 'white' : ''"
    [formGroup]="emailForm">
    <div class="top">
      <!-- RingCentral not-connected banner (SMS mode only) -->
      <div class="rc-connect-banner" *ngIf="isSms && rcProvider === 'ringcentral' && !rcConnected">
        <mat-icon class="rc-banner-icon">error_outline</mat-icon>
        <div class="rc-banner-text">
          <strong>RingCentral not connected.</strong>
          <span>Connect your RingCentral account to send SMS from your own number.</span>
        </div>
        <button mat-flat-button color="primary" class="rc-banner-btn" (click)="goToConnectRc()">
          <mat-icon>link</mat-icon> Connect
        </button>
      </div>

      <!-- Wrap input and icon together -->
      <div class="input-icon-wrapper" *ngIf="!createEmail && !replyEmail">
        <input 
          [placeholder]="isSms?'Click here to send SMS...': hasEmailToReply ? 'Click here to reply last Email...' : 'Click here to compose an Email'"
          (focus)="expandEditor()" />
        <mat-icon class="add-icon">add</mat-icon>
      </div>

      <!-- <div class="noSyncGmail" *ngIf="!isSms && !isEmailSync && messages?.length>0 && showGmailBanner"> -->
        <!-- Close button inside noSyncGmail -->
        <!-- <div class="close-btn" (click)="close()">×</div>
        <div>
          <span style="font-size: 20px;">Please connect to Gmail!</span>
        </div>
        <button mat-raised-button style="background-color: #f03333; color: white;margin-right: 10px;" (click)="connectEmail()">
          Connect <mat-icon>alternate_email</mat-icon>
        </button>
      </div> -->

      <ng-container *ngIf="createEmail || replyEmail">
        <div style="background-color: white">
          <app-sms *ngIf="isSms" [lead]="currentLead" [isSendingMessage]="true"
            [formControl]="$any(emailForm).get('content')" (templateChosen)="staticTemplateFiles($event)" [placeholder]="'Send sms...'" [height]="'200'"></app-sms>
        </div>
          <!-- Modern Reply Header - separate from app-email-format -->
          <div class="email-reply-container" *ngIf="replyEmail && !isSms">
            <div class="reply-header">
              <div class="reply-icon">
                <mat-icon>reply</mat-icon>
              </div>
              <div class="reply-details">
                <div class="reply-field">
                  <label>Reply To:</label>
                  <span class="reply-value">{{ currentLead.email }}</span>
                </div>
                <div class="reply-field">
                  <label>Subject:</label>
                  <span class="reply-value">{{ replySubject || 'No Subject' }}</span>
                </div>
              </div>
            </div>
          </div>
  
        <div *ngIf="(createEmail || replyEmail) && !isSms" style="background-color: white;">

          <!-- Keep app-email-format separate as you requested -->
          <app-email-format
            (templateChosen)="staticTemplateFiles($event)"
            [emailForm]="emailForm"
            [isCreate]="createEmail"
            [currentLead]="currentLead"
            [signatures]="signatures"
            [isSms]="isSms"
          ></app-email-format>
        </div>

        <app-attach-section 
          [showSentButons]="true" 
          [isSms]="isSms" 
          [currentUser]="currentUser"
          [signatures]="signatures"
          (attachFile)="newFileAttach($event)" 
          (signatureSelect)="manageSelectSignature($event)" 
          (signatureAdd)="manageSignatures()" 
          (trashButton)="cancel()"
          (sendButton)="sendEmailOrSms()">
        </app-attach-section>
  

        <app-display-file 
          *ngIf="attachedFiles?.length>0 || staticFiles?.length>0" 
          [attachedFiles]="attachedFiles" 
          [fixedFiles]="staticFiles" 
          (removeFileStatic)="staticTemplateFiles($event)" 
          (removeFileFromCache)="removeFileFromCache($event)"
          [isSendingMessage]="true"
          [isSms]="isSms"
          [formControl]="validateFiles">
        </app-display-file>

      </ng-container>
    </div>
    <div class="chat-card" *ngIf="(!createEmail || isSms )&& messages.length>0">
      <!-- Static Header -->
      <!-- Static Header -->
<div class="chat-header" *ngIf="!replyEmail">
  <div class="left-header">
    <mat-icon class="email-icon" [ngStyle]="{ color: !isSms ? '#ffff2c' : 'inherit' }">email</mat-icon>|
    <mat-icon class="email-icon" [ngStyle]="{ color: isSms ? '#ffff2c' : 'inherit' }">smartphone</mat-icon> Chat
    History
  </div>
  <div class="right-header">
    <!-- Mark as Read button — only when there are unseen messages -->
    <button *ngIf="hasUnseenReply" 
            mat-stroked-button 
            class="mark-read-btn" 
            (click)="markAsRead()">
      <mat-icon>markunread</mat-icon> Mark as Read
    </button>
    <!-- All read indicator — only when messages exist but all are read -->
    <span *ngIf="!hasUnseenReply && messages?.length > 0" class="all-read-indicator">
      <mat-icon>done_all</mat-icon> All read
    </span>
    <button *ngIf="!isSms" mat-raised-button color="primary" (click)="composeEmail()">Compose <mat-icon>send</mat-icon></button>
  </div>
</div>
  
      <!-- Scrollable Chat Items -->
      <div class="chat-content">
        <div class="chat-item" *ngFor="let chat of messages; let isLast = last">
          <app-chat-item
            (chatReply)="replySpecificEmail($event)"
            (infoChat)="infoChat($event)"
            [chat]="chat"
            [isEmailSync]="isEmailSync"
            [currentUser]="currentUser"
            [leadName]="currentLead.fullName"
            [repName]="fullNameCurrentUser"
            [isLast]="isLast"
          ></app-chat-item>
        </div>
      </div>

        <div *ngIf="showLoad" class="load-more-container">
          <button mat-button (click)="loadMore()">
            <mat-icon>cached</mat-icon> Load More
          </button>
        </div>
    </div>
  
    <!-- Compact Empty State for small heights -->
    <div class="compact-empty-container" *ngIf="!createEmail && !replyEmail && messages.length === 0">
      <div class="compact-empty-state" *ngIf="!isSms; else compactSmsEmpty">
        <mat-icon class="compact-icon">inbox</mat-icon>
        <div class="compact-text">
          <p class="compact-title">Empty Inbox</p>
          <p class="compact-description">Incoming emails will appear here</p>
        </div>
        <button mat-flat-button color="primary" class="compact-button" (click)="composeEmail()">
          <mat-icon>edit</mat-icon>
        </button>
      </div>
      
      <ng-template #compactSmsEmpty>
        <div class="compact-empty-state">
          <mat-icon class="compact-icon">message</mat-icon>
          <div class="compact-text">
            <p class="compact-title">Empty SMS Inbox</p>
            <p class="compact-description">Incoming messages will appear here</p>
          </div>
          <button mat-flat-button color="primary" class="compact-button" (click)="composeEmail()">
            <mat-icon>sms</mat-icon>
          </button>
        </div>
      </ng-template>
    </div>
    
    <!-- Regular Empty State for normal heights (hidden for heights under 900px) -->
    <div class="center-container regular-empty-container" *ngIf="!createEmail && !replyEmail && messages.length === 0">
      <!-- Email card if not SMS -->
      <mat-card class="inbox-card" *ngIf="!isSms; else smsCard">
        <div class="icon-container">
          <mat-icon class="large-icon" color="primary">inbox</mat-icon>
        </div>
        <h2 class="title">Your Inbox Is Empty</h2>
        <p class="description">
          All incoming email requests will be listed in this folder.
        </p>
        <button mat-raised-button color="primary" (click)="composeEmail()">
          Compose <mat-icon>send</mat-icon>
        </button>
      </mat-card>
    
      <!-- SMS card template -->
      <ng-template #smsCard>
        <mat-card class="inbox-card">
          <div class="icon-container">
            <mat-icon class="large-icon" color="primary">message</mat-icon>
          </div>
          <h2 class="title">Your SMS Inbox Is Empty</h2>
          <p class="description">
            All incoming SMS requests will be listed here.
          </p>
          <button mat-raised-button color="primary" (click)="composeEmail()">
            Send <mat-icon>send</mat-icon>
          </button>
        </mat-card>
      </ng-template>
    </div>
  </div>
</div>